import React from 'react';
import { NavLink } from 'react-router-dom';
import './PageNotFound.css';

const PageNotFound = () => {
  return (
    <div className="page-not-found-section">
      <div className="page-not-found-container">
        <div className="page-not-found-text-content">
          <h1 className="page-not-found-error-code">404</h1>
          <h2 className="page-not-found-title">Page Not Found</h2>
          <p className="page-not-found-description">
            We're sorry, the page you requested could not be found. It might have been moved, renamed, or is temporarily unavailable.
          </p>
          <NavLink to="/" className="page-not-found-home-button">
            RETURN TO HOMEPAGE
          </NavLink>
        </div>
        <div className="page-not-found-graphic-content">
          <svg
            className="page-not-found-svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="#1E2A78"
              d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 464c-114.7 0-208-93.3-208-208S141.3 48 256 48s208 93.3 208 208-93.3 208-208 208z"
            />
            <path
              fill="#F4A124"
              d="M232 152h48v152h-48zM232 328h48v48h-48z"
            />
          </svg>
          <div className="page-not-found-magnifying-glass">
             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#1E2A78" d="M416 208c0 45.9-14.9 88.3-40 122.7L500 454.7l-22.6 22.6-124.7-124.7C316.3 389.1 273.9 404 228 404c-114.9 0-208-93.1-208-208S113.1 0 228 0s208 93.1 208 208zM228 64C149.8 64 84 129.8 84 208s65.8 144 144 144 144-65.8 144-144-65.8-144-144-144z"/></svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;